import { TiTick } from "react-icons/ti";
import bannerImg from "@assets/images/IoT-Development.avif";
// import bannerImg from '@assets/images/mobile-app-development-iconn.png'
import RippleButton from "@components/RippleAnimation";
import { motion } from "framer-motion";
import { Head } from "vite-react-ssg";
// import "./index.css";
import CustomBanner from "../../../../components/CustomBanner";
import GetAQuoteButton from "../../../../components/GetAQuoteButton";
import FrostedContainer from "../../../../components/FrostedContainer";
// import IoTDevelopmentCTAImage from "@assets/images/IoTDevelopmentCTAImage.avif";

export const Banner = () => {
  return (
    <> 
        <Head>
             <title>IoT Development Company in the Washington Metro Area</title>
             <meta
               name="description"
               content="Build smart, connected solutions with our IoT development services for the Washington Metropolitan Area. We help small businesses design, deploy, and manage IoT systems."
             />
             <link
               rel="canonical"
               href="https://apptalyst.com/IoT-development"
             />
           </Head>  
           <CustomBanner        
             bgImg={bannerImg} 
                    customHeight={true}

             BannerImageAlt="A low-fidelity UI/UX design showing the skeleton, important components and work-flow of a website."
           > 
             <div className="flex justify-start flex-start ">
     
           
             {/* <div className="bg-[rgba(255,255,255,0.1)] backdrop-blur-[10px] border border-[rgba(255,255,255,0.3)] rounded-[40px] [border-image-source:radialgradient(81.59%_81.59%_at_18.48%_100%,_#FFFFFF_0%,_rgba(255,255,255,0)_100%),_radial-gradient(88.88%_88.88%_at_4.11%_6.2%,_#FFFFFF_0%,_rgba(255,255,255,0)_100%)] [border-image-slice:1]  px-5 py-5 md:px-10 md:py-10 mt-20 space-y-6 text-white w-full  "> */}
             <FrostedContainer>

             {/* <div className="frosted-card"> */} 
               <motion.div
                 initial={{ opacity: 0, y: 40 }}  
                 whileInView={{ opacity: 1, y: 0 }}
                 transition={{ duration: 0.8, ease: "easeOut" }}
                 viewport={{ once: true, amount: 0.3 }} 
                 
               >
                 <h1 className="text-[30px] md:text-[38px] lg:text-[47px] xl:text-[52px] 2xl:text-[67px]  leading-[1.1] font-bold md:pr-0 heading-1 text-white">
                   IoT Development Company for the Washington Metropolitan Area
                 </h1> 
               </motion.div>
               
               <p className="text-base leading-[1.625rem] font-semibold text-white paragraph ">
                We’re a premier IoT development company dedicated to transforming complex hardware visions into scalable, market-ready realities. We provide end-to-end IoT development services that bridge the gap between physical sensors and sophisticated cloud intelligence for businesses of all sizes.

               </p>
  <ul className="space-y-5 lg:space-y-2 text-lg px-2 md:px-0">
                    <li className="flex items-start text-white text-base leading-[1.625rem] space-x-2">
                      <span className="text-dark  bg-[#FFC067] rounded-full p-0.5  mt-1">
                        <TiTick />
                      </span>

                      <div>
                        <span className="inline font-bold m-0 text-lg">
                          Consultative Approach:{" "}
                        </span>{" "}
                        <span className="text-base leading-[1.625rem] font-semibold">
                        We act as your IoT consulting partner, guiding you from initial circuit design to global deployment.

                        </span>
                      </div>
                    </li>
                    <li className="flex items-start text-white text-base leading-[1.625rem] space-x-2">
                      <span className="text-dark  bg-[#FFC067] rounded-full p-0.5  mt-1">
                        <TiTick />
                      </span>

                      <div>
                        <span className="inline font-bold m-0 text-lg">
                          Scalable Architecture: 
                        </span>{" "}
                        <span className="text-base leading-[1.625rem] font-semibold">
 Our IoT solutions are built on robust cloud infrastructure designed to grow from a single prototype to a fleet of thousands.

                        </span>
                      </div>
                    </li>
                    <li className="flex items-start text-white text-base leading-[1.625rem] space-x-2">
                      <span className="text-dark  bg-[#FFC067] rounded-full p-0.5  mt-1">
                        <TiTick />
                      </span>

                      <div>
                        <span className="inline font-bold m-0 text-lg">
                          Innovation-driven:{" "}
                        </span>{" "}
                        <span className="text-base leading-[1.625rem] font-semibold">
We specialize in integrating AI and machine learning capabilities at the edge, ensuring your product stays ahead of the 2026 technological curve.
                        </span>
                      </div>
                    </li>
                  
                  
                  </ul>
     
             
             </FrostedContainer>

             </div>
             {/* </div> */}

     
           </CustomBanner>
    </>
  );
};
